import { Avatar } from "@/components";
import { Typography } from "@/components/text";
import { getRandomColor } from "@/libraries/colors";
import type { UserStatus } from "@/libraries/constant";
import Stack from "@mui/material/Stack";
import type { FC } from "react";

interface PersonInfoProps {
	avatar: string | null;
	status: UserStatus;
	fullName: string;
	jobTitle: string | null;
	hospitalName: string | null;
	isMe?: boolean;
}

const PersonInfo: FC<PersonInfoProps> = (props) => {
	const {
		avatar,
		status,
		fullName,
		jobTitle,
		hospitalName,
		isMe = false,
	} = props;

	const initial = fullName?.trim()?.charAt(0)?.toUpperCase() ?? "L";
	const hexColor = getRandomColor(fullName);
	const name = `${fullName}${isMe ? " (Me)" : ""}`;

	return (
		<Stack
			gap={2}
			direction="row"
			justifyContent="start"
			alignItems="center"
			className="h-full"
		>
			<Avatar
				className="!bg-zinc-200 !text-dark"
				src={avatar ?? undefined}
				sx={{ width: 48, height: 48 }}
				status={status}
			>
				{initial}
			</Avatar>
			<Stack direction="column" justifyContent="center" alignItems="start">
				<Typography fontSize={14} fontWeight={500} color={hexColor}>
					{name}
				</Typography>
				{jobTitle ? (
					<Typography fontSize={14} fontWeight={500}>
						{jobTitle}
					</Typography>
				) : null}
				{hospitalName ? (
					<Typography fontSize={14} fontWeight={400}>
						{hospitalName}
					</Typography>
				) : null}
			</Stack>
		</Stack>
	);
};

export default PersonInfo;
